import { nav } from "../components/nav/script";
import { searchbar } from "../components/forms/searchbar/script";
import { listFilter } from "../components/inputs/list_filter/script";
import { highlightSearchTerms } from "./utils";
import LazyLoad from "./vendor/lazyload.esm.min";

const FILTER_CLASS_PATTERN = /filter--[a-z\-\d]+/;
const debouncedResizeEvent = new Event("debouncedResize");
const body = document.querySelector("body");
const pageName = body.dataset.page;
const targetSelect = body.querySelector("#target-select");
let debounce;

window.addEventListener("DOMContentLoaded", (e) => {
    let prevWidth = window.innerWidth;
    let lazyLoad = new LazyLoad({
        elements_selector: ".lazy",
        threshold: 150,
        cancel_on_exit: true
      });

    window.addEventListener("resize", () => {
        clearTimeout(debounce);
        body.classList.add("resizing");

        debounce = setTimeout(() => {
            const newWidth = window.innerWidth;
            const widthChanged = newWidth !== prevWidth;

            if (widthChanged) {
                body.classList.remove("resizing", "nav-active");
                window.dispatchEvent(debouncedResizeEvent);
                prevWidth = newWidth;
            }
        }, 250);
    });

    nav.init();
    searchbar.init();
    listFilter.init(FILTER_CLASS_PATTERN, pageName === "the-rescues");

    if (searchData) {
        highlightSearchTerms(searchData);
    }

    if (typeof dynamicImports !== "undefined") {
        Object.keys(dynamicImports).forEach(moduleName => {
            initModule(moduleName, dynamicImports[moduleName]);
        });
    } else {
        console.log("dynamicImports undefined");
    }
});

window.addEventListener("load", () => {
    body.classList.remove("no-transition");
});

window.addEventListener("filterSelectMenu", () => {
    if (targetSelect) {
        targetSelect.selectedIndex = 0;
    }
});

const initFunctions = {
    floorPlan: (importedModule) => {
        const filterClasses = ["ground", "first", "second"];
        importedModule.init(filterClasses);
    },
    map: (importedModule) => {
        const snappingRequired = [
            "the-rescues"
        ];
        const pageName = document.querySelector('body').dataset.page;
        const snap = snappingRequired.includes(pageName);

        importedModule.init(snap);
    },
    boatDetails: (importedModule) => {
        importedModule.init();
    },
    selectTarget: (importedModule) => {
        importedModule.init(FILTER_CLASS_PATTERN);
    },
    selectCategory: (importedModule) => {
        importedModule.init();
    },
    lightbox: (importedModule) => {
        const zoomable = body.classList.contains("lb-zoom");
        importedModule.init(zoomable);
    }
};

const initModule = async (moduleName, moduleDirectory) => {
    const initFunc = initFunctions[moduleName];

    if (initFunc) {
        const importedModule = await import(`./../components/${moduleDirectory}/script`);
        initFunc.call(this, importedModule[moduleName]);
    }
}

const getActiveBreakpointNumber = () => {
    const breakpointString = getComputedStyle(document.documentElement).getPropertyValue("--breakpoint");
    return parseInt(breakpointString, 10);
}
